import { useDispatch, useSelector } from "react-redux";
import Books from "../books/Books";
import { filterByfeatured } from '../../features/filter/filterSlice';


export default function Home() {
    //Variables
    const dispatch = useDispatch();
    const { featured } = useSelector((state) => state.filter)

    //Functions
    const handleFilterByFeature = (featured) => {
        dispatch(filterByfeatured(featured));
    }

    return (
        <main className="py-12 px-6 2xl:px-6 container">
            <div className="order-2 xl:-order-1">
                <div className="flex items-center justify-between mb-12">
                    <h4 className="mt-2 text-xl font-bold">Book List</h4>

                    <div className="flex items-center space-x-4">
                        <button className={`lws-filter-btn ${featured==="all" && "active-filter"}`} onClick={() => handleFilterByFeature("all")}>All</button>
                        <button className={`lws-filter-btn ${featured==="featured" && "active-filter"}`} onClick={() => handleFilterByFeature("featured")}>Featured</button>
                    </div>
                </div>
                <Books />
            </div>
        </main>
    );
}
